module.exports = __webpack_public_path__ + "img/new-treatment-modal-mobile-ru.53ebf6f5.jpg";